export const base_URL = "https://api.findmyvenue.com";
// export const base_URL = "http://localhost:8000";
export const frontend_URL = "https://www.findmyvenue.com";
//export const frontend_URL = "http://localhost:3000";
export const cdn_URL = process.env.REACT_APP_CDN_URL || "https://images.findmyvenue.com";
